<template>
  <div>
    <ul class="query-container">
      <li v-for="(item, index) in queryArr" @click="setCurrent(item)" :key="index" :class="column ? 'col-'+column :''">
        <template v-if="!item.disabled">
          <label :style="{'width': labelWidth+'px'}"><span class="required-icon" v-if="item.required">*&nbsp;&nbsp;</span>{{item.label}}&nbsp;&nbsp;</label>
          <div class="query-content" :style="{'width': item.labelWidth ? (+item.labelWidth) +'px': ((item.queryType === 'dateRange' || item.queryType === 'date' && item.type === 'datetimerange') ? (+labelWidth + 40 + 300) +'px':'200px') }">
            <el-input
              v-model.trim="form[item.key]"
              v-if="item.queryType==='input'"
              v-bind="item"
              :maxlength="item.maxLength"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              clearable
              size="small"
              @change="item.change"
              @blur="item.blur(form[item.key])"
              @focus="item.focus"
              v-domEnter="item.enterMethod ? () => enterSearch(item) : query">
            </el-input>
            <!-- 带按钮的输入框 -->
            <el-input
              v-model.trim="form[item.key]"
              v-if="item.queryType==='inputButton'"
              v-bind="item"
              :maxlength="item.maxLength"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              clearable
              size="small"
              @change="item.change"
              @blur="item.blur(form[item.key])"
              @focus="item.focus"
            >
              <template slot="append">
                <!-- @slot 带按钮的输入框 -->
                <el-button slot="goodsIdSlot" class="gc-mw82" size="small" type="primary" @click="$emit(item.slotEvent, form)">{{item.slotButton}}</el-button>
              </template>
            </el-input>
            <el-input
              class="input-with-select"
              v-model.trim="form[item.key]"
              v-if="item.queryType==='inputSelect'"
              v-bind="item"
              :maxlength="item.maxLength"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              clearable
              :disabled="!form[item.select.key]"
              size="small"
            >
              <el-select
                slot="prepend"
                v-model="form[item.select.key]"
                :placeholder="item.select.placeholder ? item.select.placeholder : '请选择'"
                :filterable="!!item.select.filterable"
                clearable
                @change="item.select.change"
                size="small"
              >
                <el-option
                  :label="i[item.select.labelKey||selectLabelKey]"
                  :value="i[item.select.valueKey||selectValueKey]"
                  v-for="(i, index) in item.select.list"
                  :key="index || i[selectLabelKey]">
                </el-option>
              </el-select>
            </el-input>
            <!-- 手机号 -->
            <input-phone
              v-if="item.queryType==='phone'"
              v-model="form[item.key]"
              clearable
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              className="gc-w200"
              :is-yxy-enter="item.enterMethod ? () => enterSearch(item) : query"
              ></input-phone>
            <!-- 最小值And最大值 -->
            <template v-if="item.queryType==='minAndMax'">
              <el-input
                v-model.trim="form[item.list[0].key]"
                v-bind="item.list[0]"
                placeholder="请输入"
                clearable
                size="small"
              >
              </el-input>
              <span class="pd10">至</span>
              <el-input
                v-model.trim="form[item.list[1].key]"
                v-bind="item.list[1]"
                placeholder="请输入"
                clearable
                size="small"
              >
              </el-input>
            </template>
            <el-select
              v-model="form[item.key]"
              v-else-if="item.queryType==='select'"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              :filterable="!!item.filterable"
              :multiple="!!item.multiple"
              v-bind="item"
              clearable
              size="small"
              @change="item.change"
              @blur="item.blur"
              @focus="item.focus"
              @clear="item.clear">
              <el-option
                :label="i[item.labelKey||selectLabelKey]"
                :value="i[item.valueKey||selectValueKey]"
                v-for="(i, index) in item.list"
                :key="index || i[selectLabelKey]">
              </el-option>
            </el-select>
            <template v-else-if="item.queryType==='dateRange'">
              <template v-if="item.type === 'dataTime'">
                <input-date-range
                :startTime.sync="form[item.list[0].key]"
                :endTime.sync="form[item.list[1].key]"
                :startTimeDefault="item.list[0].value || ''"
                :endTimeDefault="item.list[1].value || ''"
                :formItem="false"
                :required="false"
                ></input-date-range>
                <!-- <el-date-picker
                  v-model="form[item.list[0].key]"
                  v-bind="item.list[0]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="00:00:00"
                  type="datetime"
                  size="small"
                  placeholder="请选择">
                </el-date-picker>
                <span class="pd10">至</span>
                <el-date-picker
                  v-model="form[item.list[1].key]"
                  v-bind="item.list[1]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59"
                  type="datetime"
                  size="small"
                  placeholder="请选择">
                </el-date-picker> -->
              </template>
              <template v-else-if="item.type === 'dataTimeRange'">
                <el-date-picker
                  v-model="form[item.key]"
                  v-bind="item"
                  type="daterange"
                  size="small"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </template>
              <!-- 单个时间选择 -->
              <template v-else-if="item.type === 'dateTimePicker'">
                <el-date-picker
                  v-model="form[item.key]"
                  v-bind="item"
                  type="datetime"
                  size="small"
                  value-format="timestamp"
                  range-separator="-"
                  placeholder="选择日期时间">
                </el-date-picker>
              </template>
              <!-- 日期区间选择器 -->
              <template v-else>
                <el-date-picker
                  v-model="form[item.list[0].key]"
                  v-bind="item.list[0]"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择">
                </el-date-picker>
                <span class="pd10">至</span>
                <el-date-picker
                  v-model="form[item.list[1].key]"
                  v-bind="item.list[1]"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择">
                </el-date-picker>
              </template>
            </template>
            <yxy-dic-select
              v-model="form[item.key]"
              size="small"
              v-else-if="item.queryType==='dictSelect'"
              v-bind="item"
            ></yxy-dic-select>
            <template v-else-if="item.queryType==='numberRange'">
              <el-input-number
                v-model.trim="form[item.list[0].key]"
                v-bind="item.list[0]"
                size="small"
                :controls="false">
              </el-input-number>
              <span class="pd10">至</span>
              <el-input-number
                v-model.trim="form[item.list[1].key]"
                v-bind="item.list[1]"
                size="small"
                :controls="false">
              </el-input-number>
            </template>
            <template v-else-if="item.queryType==='tree'">
              <el-cascader
                :placeholder="item.placeholder"
                size="small"
                :style="{width:'100%'}"
                :options="item.list"
                :props="item.props"
                filterable
                change-on-select
                clearable
                @change="treeChangeHandler(item)"
                v-model="item.valueList"
                popper-class="cascader-tree"
              >
              </el-cascader>
            </template>
            <template v-else-if="item.queryType==='treeMulti'">
              <el-cascader-multi
                :placeholder="item.placeholder"
                size="small"
                clearable
                v-model="form[item.key]"
                :value-key="item.props.valueKey"
                :label-key="item.props.labelKey"
                :children-key="item.props.childrenKey"
                :data="item.data"
                @change="cascaderMultiChange($event,item)"
                class="cascader-multi"
              ></el-cascader-multi>
            </template>
            <template v-else-if="item.queryType==='elTreeMulti'">
              <el-cascader
                :placeholder="item.placeholder"
                size="small"
                clearable
                v-model="form[item.key]"
                :props="item.props"
                :options="item.data"
                @change="cascaderMultiChange($event,item)"
                class="cascader-multi"
              ></el-cascader>
            </template>
            <!-- cascader multi -->
            <template v-else-if="item.queryType==='cascaderMulti'">
              <el-cascader
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
                size="small"
                :style="{width:'100%'}"
                :options="item.list"
                :props="item.props"
                clearable
                :collapse-tags="item.isCollapseTags"
                v-model="shareScope"
                @change="changeLabel($event, item)"
                :popper-class="item.popperClass"
              >
              </el-cascader>
            </template>
            <!--- input + tag -->
            <template v-else-if="item.queryType === 'inputTag'">
              <div class="input-tag-box">
                <el-tag
                  :key="tag"
                  v-for="tag in dynamicTags"
                  :size="item.tagSize"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag, item)"
                >
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="mini"
                  :maxlength="item.maxLength"
                  @keyup.enter.native="handleInputConfirm(item)"
                  @blur="handleInputConfirm(item)"
                >
                </el-input>
                <el-button v-else-if="!inputVisible && isShowInputTagBtn" class="button-new-tag" size="mini" @click="showInput">+ 添加</el-button>
              </div>
            </template>
          </div>
        </template>
      </li>
      <li :class="column ? 'col-'+column :''" v-if="queryArr.length < 3 || btnDisplay === 'inline'" style="justify-content: center;">
        <el-row type="flex" justify="end">
          <el-button v-if="isYxyEnter" v-yxyEnter="query" v-debounceClick class="gc-mw82" type="primary" size="small" @click="query">查询</el-button>
          <el-button v-else v-debounceClick class="gc-mw82" type="primary" size="small" @click="query">查询</el-button>
          <el-button class="gc-mw82" size="small" @click="reset">重置</el-button>
          <!-- @slot 按钮栏添加自定义按钮 -->
          <slot name="btnItem"></slot>
        </el-row>
      </li>
      <slot name="queryItem"></slot>
    </ul>
    <div class="query-btn-container" v-if="queryArr.length >= 3 && btnDisplay === 'block'">
      <el-button v-if="isYxyEnter" v-yxyEnter="query" v-debounceClick class="gc-mw82" type="primary" size="small" @click="query">查询</el-button>
      <el-button v-else v-debounceClick class="gc-mw82" type="primary" size="small" @click="query">查询</el-button>
      <el-button class="gc-mw82" size="small" @click="reset">重置</el-button>
      <!-- @slot 按钮栏添加自定义按钮 -->
      <slot name="btnItem"></slot>
    </div>
  </div>

</template>
<script>
  import { serialize } from '@/utils/serizlize';
  import { deepClone } from '@/utils';
  import InputNumber from '@/components/EditableItem/inputNumber';
  import InputPhone from '@/components/InputPhone';
  import InputDateRange from '@/components/InputDateRange';
  /**
   * 搜索器
   * @displayName 搜索器
   */
  export default {
    name: 'QueryBar',
    props: {
      /**
       * 配置搜索项
       */
      queryList: {
        type: Array,
        required: true
      },
      /**
       * 搜索项的默认值
       */
      defaultValues: {
        type: Object,
        default: null
      },
      /**
       * label的宽度
       */
      labelWidth: {
        type: [Number, String],
        default: 80
      },
      /**
       * 搜索项的键值
       */
      selectLabelKey: {
        type: String,
        default: 'name'
      },
      /**
       * 搜索项的value值
       */
      selectValueKey: {
        type: String,
        default: 'value'
      },
      /**
       * @model
       */
      value: {
        type: Object
      },
      /**
       * 每行展示的列数
       */
      column: {
        type: [Number, String],
        default: 3
      },
      /**
       * 是否支持回车查询
       */
      isYxyEnter: {
        type: Boolean,
        default: false
      },
      // 查询按钮位置
      /**
       * @ignore
       */
      btnDisplay: {
        type: String,
        default: 'block'
      }
    },
    data() {
      return {
        form: {},
        noop: function() {},
        current: {},
        props: {
          value: 'id'
        },
        // 标签输入
        dynamicTags: [],
        inputVisible: false,
        inputValue: '',
        isShowInputTagBtn: true,
        shareScope: [],
        shareScopeEnd: [],
      };
    },
    mounted() {
      this.$nextTick(() => {
        // if (this.defaultValues) {
        //   this.form = JSON.parse(JSON.stringify(this.defaultValues));
        //   this.$emit('query', serialize(this.form));
        // }
      });
      // 配合样式控制（看该文件底部样式声明） + 控制点击右箭头icon也要触发选中功能
      setInterval(function() {
        document.querySelectorAll('.cascader-tree .el-cascader-node__postfix').forEach(el => {
          el.onclick = function() {
            if (this.previousElementSibling && this.previousElementSibling.previousElementSibling) this.previousElementSibling.previousElementSibling.click();
          };
        });
      }, 1000);
    },
    components: {InputNumber, InputPhone, InputDateRange},
    methods: {
      query() {
        /**
         * 点击“搜索”按钮，执行的回调事件.
         * *
          * @property {Object} form 搜索参数
         */
        this.$emit('query', serialize(this.form));
      },
      // 重置操作，每增加一种类型可能需要改动这里
      reset() {
        this.form = {};
        this.queryArr.forEach(item => {
          if (item.queryType === 'tree') {
            item.valueList = [];
          } else if (item.queryType === 'select' && item.multiple) {
            this.$set(this.form, item.key, []);
          } else if (item.queryType === 'cascaderMulti') {
            this.$set(this.form, item.key, []);
            this.shareScope = [];
            this.shareScopeEnd = [];
          } else if (item.queryType === 'inputTag') {
            this.$set(this.form, item.key, []);
            this.inputValue = '';
          }
        });
        /**
         * 点击“重置”按钮，执行的回调事件.
         */
        this.$emit('reset');
      },
      setCurrent(item) {
        this.current = item;
      },
      extend(target, source, extendKeyList = []) {
        extendKeyList.forEach((item) => {
          target[item] = source[item];
        });
        return target;
      },
      treeChangeHandler(val) {
        for (let i = 0; i < val.key.length; i++) {
          // this.form[val.key[i]] = val.valueList[i];
          this.$set(this.form, val.key[i], val.valueList[i]);
        }
      },
      cascaderMultiChange(val, item) {
        if (!item.maxLen) return;
        if (val.length > item.maxLen) {
          this.$set(this.form, item.key, val.slice(0, item.maxLen));
          this.$gcInfoMsg('自定义标签最多可选' + item.maxLen + '个');
        }
      },
      // 回车搜索时间
      enterSearch(item) {
        let itemFrom = serialize(this.form);
        item.enterMethod(itemFrom);
      },
      // 标签删除
      handleClose(tag, item) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.form[item.key] = this.dynamicTags;
        if (this.dynamicTags.length === item.inputTagLength) {
          this.isShowInputTagBtn = false;
        } else {
          this.isShowInputTagBtn = true;
        }
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm(item) {
        let inputValue = this.inputValue;
        if (inputValue) {
          if (item.inputLength && inputValue.length !== item.inputLength) {
            this.$gcInfoMsg(item.inputLengthErrorMsg);
            return;
          }
          if (item.isNotAllowRepeat && this.dynamicTags.indexOf(inputValue) >= 0) {
            this.$gcInfoMsg(item.isNotAllowRepeatMsg);
            return;
          }
          this.dynamicTags.push(inputValue);
        }
        this.form[item.key] = this.dynamicTags;
        if (this.dynamicTags.length === item.inputTagLength) {
          this.isShowInputTagBtn = false;
        } else {
          this.isShowInputTagBtn = true;
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      changeLabel(val, item) {
        if (item.firstSingleSecondMulti) {
          // 控制一级单选，二级多选
          // 是否与上次的类型相同
          let changeFlag = false;
          if (this.shareScopeEnd.length === 0) {
            this.shareScope = val;
          } else {
            // 与原数组比对
            this.shareScope.forEach((item) => {
              // 与原数组的类型相同
              if (item[0] !== this.shareScopeEnd[0][0]) {
                changeFlag = true;
              }
            });
          }
          if (changeFlag) {
            this.shareScope = this.shareScope.filter((item) => {
              return (item[0] !== this.shareScopeEnd[0][0]);
            });
          }
        } else { // 不做限制
          const isHasAll = item['addAllOption']['isAdd'];
          const ALL_CODE = item['addAllOption']['value'];
          // 构造全部的数据
          const allTreeData = [];
          Array.isArray(item.list) && item.list.forEach(pItem => {
            const valueProp = item['props']['value'];
            const childrenProp = item['props']['children'];
            const children = pItem[childrenProp];
            // 把“不限”选项添加进去
            if (isHasAll && pItem[valueProp] === ALL_CODE) {
              const arr = [];
              arr.push(pItem[valueProp]);
              allTreeData.push(arr);
            }
            Array.isArray(children) && children.forEach(cItem => {
              const arr = [];
              arr.push(pItem[valueProp]);
              arr.push(cItem[valueProp]);
              allTreeData.push(arr);
            });
          });
          // 记录上一次是否选中  不限
          let isChooseAllEnd = false;
          // 记录当前是否选中  不限
          let isChooseAll = false;
          this.shareScopeEnd.forEach(item => {
            if (item[0] === ALL_CODE) {
              isChooseAllEnd = true;
            }
          });
          Array.isArray(val) && val.forEach(item => {
            if (item[0] === ALL_CODE) {
              isChooseAll = true;
            }
          });
          // 选择全部大类， 默认将 不限也勾选上
          if (!isChooseAllEnd && !isChooseAll) { // 上一次和当前没有选中 “不限”
            if (val.length + 1 === allTreeData.length) { // 除“不限”以外的选项都选中时，自动  全选
              this.shareScope = allTreeData;
            } else { // 除“不限”以外的选项没有都选中，则取val的值中时
              this.shareScopeEnd = val;
            }
          } else if (isChooseAllEnd && isChooseAll) { // 从全选状态，取消除“不限”以外的某一个选项
            this.shareScope = val.filter(item => {
              return item[0] !== ALL_CODE;
            });
          } else if (!isChooseAllEnd && isChooseAll) { // 全选
            this.shareScope = allTreeData;
          } else { // 全不选
            this.shareScope = [];
          }
        }
        this.shareScopeEnd = this.shareScope;
        this.$set(this.form, item.key, this.shareScope);
      },
    },
    computed: {
      queryArr() {
        let vm = this;
        let result = deepClone(this.queryList.filter(Boolean));
        const extendKeyList = ['change', 'blur', 'focus', 'clear'];
        const getFun = (item) => {
          let funObj = this.extend({}, item, extendKeyList);
          for (let key in funObj) {
          // 级联选择值变化处理
            if (item.queryType === 'select' && key === 'change' && item.cascadeName) {
              let cascadeList = [];
              for (let query of this.queryList) {
                if (item.cascadeName === query.cascadeName && item.level < query.level) {
                  cascadeList.push(query.key);
                }
              }
              item[key] = function(value) {
                if (value === '') {
                  cascadeList.forEach((i) => {
                    vm.form[i] = '';
                  });
                }
                funObj[key] && funObj[key](value);
              };
            } else if (item.queryType === 'tree' || item.queryType === 'treeMulti') {
              vm.$set(vm.form, item.key, vm.form[item.key] || []);
            } else if (item.queryType === 'inputSelect') {
              item.select['change'] = function(value) {
                if (!value) {
                  vm.$set(vm.form, item.key, '');
                }
              };
            } else {
              item[key] = function(value) {
                funObj[key] && funObj[key](value);
              };
            }
          }
        };
        for (let item of result) {
          if (!item.key) {
            if (item.list) {
              for (let li of item.list) {
                getFun(li);
              }
            }
          } else {
            getFun(item);
          }
        }
        return result;
      },
    },
    watch: {
      form: {
        handler(val) {
          this.$emit('input', serialize(val));
        },
        deep: true
      },
      defaultValues: {
        handler(val) {
          if (val) {
            this.$nextTick(() => {
              this.form = JSON.parse(JSON.stringify(val));
              this.$emit('query', serialize(this.form), 'defaultValues');
            });
          }
        },
        deep: true,
        immediate: true
      }
    }
  };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .query-container {
    display: flex;
    flex-flow: row wrap;
    list-style: none;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      flex-flow: row nowrap;
      margin-bottom: 10px;
      label {
        line-height: 30px;
        text-align: right;
      }
    }
    .col-2{
      flex-basis: 48%;
    }
    .col-3 {

      flex-basis: 30%;
    }
    .col-4 {
      flex-basis: 25%;
    }
    .query-content {
       width: 200px;
       display: flex;
      //  align-items: center;
    }
    .pd10{
      margin: 0 10px;
    }
    .el-select{
      width: 100%;
    }
  }

  .query-btn-container{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .required-icon{
    color: #f56c6c;
    vertical-align: middle;
  }
  .input-with-select /deep/ .el-input-group__prepend {
    background-color: #fff;
    .el-input__inner{
      width: 97px;
      cursor: pointer;
    }
    .el-input__suffix{
      right: -37px;
      .el-input__icon{
        cursor: pointer;
      }
    }
  }
  .input-with-select /deep/ .el-input__inner{
    width: 127px;
  }
.input-tag-box {
  display: block;
}
/deep/.el-tag{
  margin-right: 5px;
}
.button-new-tag {
  height: 24px;
  // line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 80px;
  margin-left: 0;
  vertical-align: bottom;
}
.cascader-multi{
  width: 100%;
}
</style>

<!-- 该样式作用在该组件dom以外的元素，所以不能用scoped局部控制 -->
<style lang="scss">
/**重置级联选择框任意层级选择样式,隐藏radio样式，点击label即可选中功能 */
.cascader-tree {
  .el-cascader-menu {
    .el-cascader-node {
      &.in-active-path, &.in-checked-path {
        font-weight: normal;
      }
      .el-radio {
        position: absolute;
        left: 0;
        opacity: 0;
        padding-left: 20px;
        width: calc(100% - 20px);
      }
      .el-cascader-node__label {
        margin-left: 0;
        padding: 0;
      }
    }
  }
}
</style>
